module.exports = __webpack_public_path__ + "static/media/mov-icon.ede9a6c8.svg";